
























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders, VAction } from '@/models/pagedlistmodel';
import { MessagesViewModel } from '@/models/telephony/message';
import { Base } from '@/components/common/base';
import { FileHelper } from '@/helper/file.helper';
import { IDialogOption } from '@/models/dialog';
import { getFaxListHeaders } from '@/views/account/message/message';
import { messageService, attachmentService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class MessageFaxListPage extends Base {
  public headers: VHeaders[] = getFaxListHeaders(this);
  public paginations = new PaginationModel('From');
  public pagedMessages: MessagesViewModel[] = [];

  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeId: number = 0;

  public loading: boolean = false;
  public searched: boolean = false;
  public actions: any[] = [];

  public associationInfo = {
    recordKey: '',
    recordIdentifier: 'RO',
    attachmentId: '',
    messageId: 0,
  };

  public associateFaxMedia: IDialogOption = {
    width: 500,
    title: this.$parent.$t('fax.associateFaxMediaDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('fax.associateFaxMediaDialog.submit') as string,
    },
    onAction: (): void => {
      this.associateMedia();
    },
  };

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'sendAdHocFax') {
      this.$router.push({ name: 'app.messages.fax.add' });
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(additionalButtons): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('fax.btnSendAdHocFax') as string,
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('fax.btnSendAdHocFax') as string,
      click: 'sendAdHocFax',
      icon: 'fas fa-plus-circle',
      requestProgress: true,
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted(): void {
    this.updateToolBar(null);
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.getMessages();
    this.setActions();
  }

  public async getMessages(): Promise<void> {
    try {
      this.loading = true;
      const response = await messageService.getFaxMessages(this.paginations);
      this.pagedMessages = response.results;
      this.paginations.totalItems = response.total;
    } finally {
      this.loading = false;
    }
  }

  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-download',
        title: this.$parent.$t(
          'fax.faxGrid.gridActions.downloadMedia'
        ) as string,
        loading: false,
        visible: (model) => {
          let attachmentId = model.recordKey;
          if (model.attachments && model.attachments.length > 0) {
            attachmentId = model.attachments[0].attachmentId;
          }
          if (attachmentId) {
            return true;
          } else {
            return false;
          }
        },
        action: (model, action: VAction) => {
          let attachmentId = model.recordKey;
          if (!attachmentId || attachmentId === '') {
            if (model.attachments && model.attachments.length > 0) {
              attachmentId = model.attachments[0].attachmentId;
            }
          }
          this.downloadAttachment(attachmentId, action);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-link',
        title: this.$parent.$t(
          'fax.faxGrid.gridActions.associateFaxMedia'
        ) as string,
        visible: (model) => {
          let attachmentId = model.recordKey;
          if (model.attachments && model.attachments.length > 0) {
            attachmentId = model.attachments[0].attachmentId;
          }
          if (attachmentId) {
            return true;
          } else {
            return false;
          }
        },
        action: (model) => {
          let attachmentId = model.recordKey;
          if (!attachmentId || attachmentId === '') {
            if (model.attachments && model.attachments.length > 0) {
              attachmentId = model.attachments[0].attachmentId;
            }
          }
          this.associationInfo.attachmentId = attachmentId;
          this.associationInfo.messageId = model.id;
          this.associateFaxMedia.model = true;
        },
      },
    ];
  }

  public updatePaging(paging: any) {
    this.paginations = paging;
    this.getMessages();
  }
  public async downloadAttachment(attachmentId: string, action: VAction) {
    if (!attachmentId || attachmentId === '') {
      // tslint:disable-next-line:max-line-length
      this.showAlert(false, this.$t('fax.alertIssueFetchingFaxMedia'));
      return;
    }
    try {
      action.loading = true;
      const response = await attachmentService.downloadAttachmentAsync(
        attachmentId
      );
      const bytes = FileHelper.base64ToArrayBuffer(response.fileBase64);
      FileHelper.downloadBytes(bytes, '', response.fileDownloadName);
    } finally {
      action.loading = false;
    }
  }

  public async associateMedia(): Promise<void> {
    if (
      !this.associationInfo.messageId ||
      this.associationInfo.messageId <= 0
    ) {
      // tslint:disable-next-line:max-line-length
      this.showAlert(
        false,
        this.$t('fax.alertProblemWithAssociatedFaxMessage')
      );
      return;
    }
    if (this.associationInfo.recordKey == '') {
      this.showAlert(false, 'Please enter RO or Deal Number ');
      return;
    }

    try {
      this.associateFaxMedia.loading = true;
      // tslint:disable-next-line:max-line-length
      await attachmentService.associateAttachmentAsync(
        this.associationInfo.attachmentId,
        this.associationInfo.messageId,
        this.associationInfo.recordKey,
        this.associationInfo.recordIdentifier
      );
      // HIDE DIALOG
      this.associateFaxMedia.model = false;

      // RESET SET VALUES
      this.associationInfo.recordKey = '';
      this.associationInfo.attachmentId = '';
      this.associationInfo.messageId = 0;
      // BIND MESSAGES
      this.getMessages();
      // SHOW SUCCESS MESSAGE
      this.showAlert(true, this.$t('fax.alertAttachmentLinkedSuccessfully'));
    } finally {
      this.associateFaxMedia.loading = false;
    }
  }
  public getRecordIdentifierPlaceholder(recordIdentifier): string {
    let placeholder = this.$parent.$t('fax.enter') as string;
    placeholder += ' ' + recordIdentifier;
    placeholder += (' ' + this.$parent.$t('fax.number')) as string;
    return placeholder;
  }
}
